import { createSelector } from 'reselect';
import { curry, curryRight } from 'lodash-es';

export const formStateSelector = (state) => state.form;
export const formsSelector = createSelector(
  formStateSelector,
  (formState) => formState && formState.forms,
);
export const googleFormsSelector = createSelector(
  formStateSelector,
  (formState) => formState && formState.googleForms,
);

const formByIdSelectorN = createSelector([formsSelector, (state, id) => id], (forms, id) =>
  forms.find((el) => el.id === id),
);
export const formByIdSelector = curryRight((a, b) => formByIdSelectorN(a, b));

export const formQuestionsSelector = createSelector(
  [(form) => form],
  (form) => form && form.formQuestions,
);
